import styled from 'styled-components';

export const ReviewStr = styled.div`
    color: #4f525a;
`;

export const RatingContainer = styled.div`
    display: flex;
`;

export const RatingBar = styled.div`
    flex-basis: 80%;
    .RatingCont__list {
        display: flex;
        flex-wrap: wrap;
        .ratingText {
            display: flex;
            justify-content: space-between;
        }
        .bars {
            margin-bottom: 1rem;
            margin-right: 3rem;
            .starText{
                font-size: 1.4rem;
                color: #0a2549;
                margin-right: 0.6rem;
            }
            .starBar {
                width: 13.8rem;
                height: 0.4rem;
                background-color: #e9eff5;
                margin-top: 6px;
                border-radius: 0.4rem;
            }
            .starBar__progress{
                height:0.4rem;
                border-radius: 0.4rem;
                display: flex;
            }
            .reviewCount{
                font-size: 1.2rem;
                flex-shrink: 0;
            }
        }
    }
`;

export const RatingCont = styled.div`
    display: flex;
    border-right: 1px solid rgba(151, 151, 151, 0.2);
    padding-right: 2rem;
    margin: ${p => p.margin ? p.margin : ''};
    margin-right: 2rem;
    align-items: center;
    .RatingCont__left{
        width: 84px;
        height: 60px;
        border-radius: 0.7rem;
        margin-right: 1.7rem;
        flex-shrink:0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
    }
    .rating{
        font-family: 'Rubik';
        font-weight: 600;
        color: #fff;
        margin-bottom: 0.8rem;
        font-size: 1.8rem;
    }
    .reviewText{
        font-family: 'Rubik';
        font-size: 1.2rem;
        color: rgba(255,255,255,0.6);
        text-transform: uppercase;
    }
`;